<template>
    <div>
        <title>商品列表</title>
        <section class="goodsBox">
        <!--S 检索-->
        <el-form :model="searchGLForm" inline class="searchForm noBtmForm">
            <el-form-item label="型号">
                <el-select v-model="searchGLForm.kindcode" popper-class="scrollSelect" filterable placeholder="请选择" clearable :filter-method="filterFlow" @focus="closeFlowName">
                    <div class="optionBox">
                        <el-option
                            v-for="item in flowList"
                            :key="item.kindcode"
                            :label="item.goodsname"
                            :value="item.kindcode">
                        </el-option>
                    </div>
                    <el-pagination
                        @current-change="flowCurrentChange"
                        :current-page="flowCurrent"
                        :page-sizes="[30]"
                        :page-size="30"
                        layout="pager"
                        :total="flowBean.totalnum" v-show="flowBean.totalnum"
                        small>
                    </el-pagination>
                </el-select>
            </el-form-item>
            <el-form-item>
            <!-- 选择会员弹窗参照 订单中心-》到店自提 -->
            <el-button type="primary" @click="querySubmit">查询</el-button>
            <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
            <el-button type="primary" plain @click="exportShow=true" v-show="!exportShow">导出</el-button>
            <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(0)">检索导出</el-button>
            <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(1)">勾选导出</el-button>
            <el-button type="danger" v-show="exportShow" icon="el-icon-close" round @click="closeExport">取消</el-button>
            </el-form-item>
        </el-form>
        <!--E 检索-->
        <div class="gsListTable individualiz">
            <!--S 商品列表-->
            <el-table ref="gsTable" class="gsTable comTable borderTable" border :data="expressStatisticsList" :maxHeight="tableHeight" @selection-change="handleSelectionChange" v-loading="loading">
                <el-table-column v-if="exportShow" type="selection" width="80"></el-table-column>
                <el-table-column type="index" label="序号" width="80" fixed="left"></el-table-column>
                <el-table-column label="型号" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.goodsname">{{scope.row.goodsname}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="数量" min-width="150">
                    <template slot-scope="scope">
                        <a @click="toStatisticsDetail(scope.row)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.num}}</a>
                    </template>
                </el-table-column>
                <template slot="empty">
                  <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <!--E 商品列表-->
        </div>
        <!-- S 分页 -->
        <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
        <!-- S 分页 -->
        </section>
    </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
    name:'FlowDeliverStatisticsList',
    data () {
        return {
            cateType:2, //当前选中菜单
            searchGLForm:{
                type: '',
                flowcode:'', 
                flowname: '',
                kindcode: '',
            },
            timeLimit:['全部','本年度','本季度','本月','本周'],//检索时限
            tableHeight: window.innerHeight*.8, //表格动态高度
            expressStatisticsList: [], // 统计数据列表
            pageSize: 30, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息
            flowList: [], // 流向方列表
            queryFlowname: '', // 检索的流向名称
            flowCurrent: 1, // 请求的商品的页面
            flowBean: { // 返回的商品分页信息
                totalnum: 0,
            },
            exportShow: false, // 是否为导出操作
            multipleSelection: [], // 选中的列表数据
            printingShow: true, // 防止多次点击导出按钮
            loading: false, // 加载中弹窗显示和隐藏
            patchName: '', // 获取上一个页面的name
        }
    },
    filters: {

    },
    components: {
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
    },
    // ============================================== 监听 ==============================================
    watch: {
        '$route'(to,from) {
            this.patchName = from.name;
        }
    },
    // ============================================== 方法 ==============================================
    methods: {
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            this.tableHeight = window.innerHeight - tbHeight - 130; 
        },
        // 查询确认事件
        querySubmit() {
            this.getExpActGoodsList();
        },
        // 获取快递发货统计记录
        getExpActGoodsList() {
            this.loading = true;
            let cardParams = {
                type: this.searchGLForm.type,
                flowcode: this.searchGLForm.flowcode, 
                flowname: this.searchGLForm.flowname,
                kindcode: this.searchGLForm.kindcode,
            };
            cardParams.pageparam = {
                pagesize: this.pageSize, //每页条数
                currentpage: this.currentPage, //当前页数
                isnewcomp: 1 //是否需要重新统计页数
            }
            api.GET_EXPACTGOODSLIST(cardParams).then(res => {
                this.loading = false;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != "null") {
                        this.expressStatisticsList = res.data.data;
                    } else {
                        this.expressStatisticsList = [];
                    }
                }
                this.pagebBean = res.data.pagebean;
            }).catch(res => {
                this.loading = false;
            })
        },
        // 接收分页信息
        updatePage(size,num) {
            this.pageSize = size;
            this.currentPage = num;
            this.getExpActGoodsList();
        },
        // 查看券卡统计信息
        toStatisticsDetail(info) {
            let ticsQueryInfo = {
                flowcode: this.searchGLForm.flowcode,
                flowname: this.searchGLForm.flowname,
                eleType: this.searchGLForm.type,
                kindcode: info.kindcode,
                goodsname: info.goodsname,
            }
            sessionStorage.setItem('ticsQueryInfo',JSON.stringify(ticsQueryInfo));
            if(this.searchGLForm.type!=0) {
                this.$router.push({
                    name: '自提发货统计详情',
                })
            } else {
                this.$router.push({
                    name: '快递发货统计详情',
                })
            }
        },
        // 获取流向方列表
        getActGoodsList() {
            let flowParams = {
                type: this.searchGLForm.type,
                flowcode: this.searchGLForm.flowcode,
                pageparam: {
                    pagesize: 30, //每页条数
                    currentpage: this.flowCurrent, //当前页数
                    isnewcomp: 1 //是否需要重新统计页数
                }
            }
            api.GET_ACTGOODSLIST(flowParams).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        this.flowList = res.data.data;
                    } else {
                        this.flowList = [];
                    }
                    this.flowBean = res.data.pagebean;
                }
            })
        },
        // 规格分页
        flowCurrentChange(val) {
            this.flowCurrent = val;
            this.getActGoodsList();
        },
        // 搜索规格方法
        filterFlow(item) {
            this.queryFlowname = item;
            this.flowCurrent = 1;
            this.getActGoodsList();
        },
        // 清除筛选的名称
        closeFlowName() {
            this.queryFlowname = '';
            this.flowCurrent = 1;
            this.getActGoodsList();
        },
        //表格多选选中行复制
        handleSelectionChange(val) { 
            this.multipleSelection = val;
        },
        // 取消导出
        closeExport() {
            this.multipleSelection = [];
            this.$refs.gsTable.clearSelection(); // 清空选中列表数据
            this.exportShow = false;
        },
        // 打印操作确认事件
        toPrinting(type) {
            if(this.printingShow) {
                let queryParams = {
                    type: this.searchGLForm.type,
                    flowcode: this.searchGLForm.flowcode, 
                    flowname: this.searchGLForm.flowname,
                    kindcode: this.searchGLForm.kindcode,
                };
                if(type == 1) {
                    if(this.multipleSelection&&this.multipleSelection.length>0) {
                        queryParams.exceltype = 1;
                        let alltotales = '';
                        this.multipleSelection.forEach(item => {
                            if(alltotales!=='') {
                                alltotales = alltotales + ',' + item.kindcode;
                            } else {
                                alltotales = item.kindcode;
                            }
                        })
                        this.loading = true;
                        this.printingShow = false;
                        queryParams.alltotale = alltotales;
                        this.exportStatistics(queryParams);
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '请至少勾选一项！'
                        })
                    }
                } else {
                    this.loading = true;
                    this.printingShow = false;
                    queryParams.exceltype = 0;
                    this.exportStatistics(queryParams);
                }
            }
        },
        // 导出数据列表
        exportStatistics(exportParams) {
            api.GET_URLFOREXPACTGOODSLIST(exportParams).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data.indexOf('http')!=-1) {
                        window.location.href = res.data.data;
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        })
                        this.closeExport();
                    } else {
                        MessageBox.confirm(`${res.data.data}`, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'success'
                        }).then(() => {
                            this.closeExport();
                        }).catch(() => {})
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
                this.printingShow = true;
                this.loading = false;
            }).catch(res => {
                this.loading = false;
                this.printingShow = true;
            })
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        if(sessionStorage.getItem('ticsQueryInfo')&&sessionStorage.getItem('ticsQueryInfo')!=undefined) {
            let ticsQueryInfo = JSON.parse(sessionStorage.getItem('ticsQueryInfo'));
            this.searchGLForm.flowcode = ticsQueryInfo.flowcode;
            this.searchGLForm.flowname = ticsQueryInfo.flowname;
            this.searchGLForm.type = ticsQueryInfo.eleType;
        };
        // 获取快递发货统计记录
        this.getExpActGoodsList();
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)

    },
    computed: {},
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    },
    activated() {
        if(this.patchName != '自提发货统计详情' && this.patchName != '快递发货统计详情') {
            if(this.patchName) {
                this.searchGLForm = {
                    type: '',
                    flowcode:'', 
                    flowname: '',
                    kindcode: '',
                }
                if(sessionStorage.getItem('ticsQueryInfo')&&sessionStorage.getItem('ticsQueryInfo')!=undefined) {
                    let ticsQueryInfo = JSON.parse(sessionStorage.getItem('ticsQueryInfo'));
                    this.searchGLForm.flowcode = ticsQueryInfo.flowcode;
                    this.searchGLForm.flowname = ticsQueryInfo.flowname;
                    this.searchGLForm.type = ticsQueryInfo.eleType;
                };
                this.pageSize = 30; // 每页展示的条数
                this.currentPage = 1; // 当前请求的页数
                // 获取快递发货统计记录
                this.getExpActGoodsList();
                //在dom渲染之后
                setTimeout(()=>{
                    this.getHeight();
                },200)
            }
        }
    },
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.goodsBox {padding:20px; height:calc(100% - 40px);}
.gsTable em{
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 20px;
  color:
  #fff;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  margin-left: 10px;
}
.gsTable .orange{background-color: #FF7018;}
.gsTable .blue{background-color: var(--main-color);}
.gsTable .iconhand::before {
  font-size: 20px;
  padding-right: 5px;
  display: inline-block;
  vertical-align: top;
}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.goodsUse {position:relative;height:36px;padding-right:15px;border-right:solid 1px #dcdfe6;}
.goodsUse em {position:absolute; left:0; top:-20px; font-size: 12px; color:#999;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}
.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.childView.takeLeft .inlineMember,.childView.helpRight .inlineMember {margin-top:0px;}
@media only screen and (max-width: 1700px) {
  .inlineMember {margin-top:10px;} 
}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px;width:auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.goodsImg{
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: solid 1px #dcdfe6;
  border-radius:100%;
  margin-right:10px;
}
.goodsImg img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  border-radius: 50%;
}
.goodsCont h3{font-size:14px!important;font-weight:bold;}
.goodsCont p{font-size:12px;}
.goodsCont{width: calc(100% - 65px);}
.actShow {padding-top:10px; color:#999;  font-size: 12px;}
.actShow span {display:inline-block; margin-right:35px;}
.actShow span b {font-weight: 600; padding-right:5px;}
.gsTable .hand{cursor: pointer;font-size: 14px;}
.el-table>>>thead.is-group th{background: #f2f3f5!important;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/ExpressStatistics/FlowDeliverStatisticsList.vue